import megatron from '@ibibo/megatron';

const VERIFY_OTP_URL = `${__ENV_CONFIG__.MYPARTNER}/agents/verify/`;

export default async function verifyOTP(userInfo) {
  let fd = new FormData();
  for (const key in userInfo) {
    fd.append(key, userInfo[key]);
  }
  
  return await megatron({
    name: 'register user api',
    url: VERIFY_OTP_URL,
    type: 'POST',
    credentials: 'include',
    requestData: fd,
  });
};
